module.exports = __webpack_public_path__ + "img/border_Circular_Right_Top.2b79a72d.svg";